<script lang="ts">
  import { page } from '$app/stores';

  import CardSelector from '$components/card-selector.svelte';
  import Button from '$components/ui/button.svelte';

  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';

  import type { ProductAsVariantStoryblok } from '$types/bloks';

  export let blocks: ProductAsVariantStoryblok[] | undefined;
</script>

{#if !!blocks?.length}
  {#each blocks as option}
    <div use:storyblokEditable={option}>
      <p class="mb-2 text-sm font-medium text-primary/60">{option.name}</p>
      <div class="flex flex-wrap gap-2">
        {#each option.options as value}
          {@const { href } = $getAnchorFromCmsLink(value.product_page)}

          {#if value.image?.filename}
            <CardSelector
              {href}
              active={$page.url.pathname === href}
              title={value.name}
              showTitle={value.show_name}
              img={value.image.filename}
              class="h-11 w-15"
              data-sveltekit-noscroll
              data-sveltekit-preload-data="hover"
              data-sveltekit-preload-code="viewport"
            />
          {:else}
            <Button
              name={value.name}
              as="a"
              {href}
              variant="radio"
              active={$page.url.pathname === href}
              size="sm"
              data-sveltekit-noscroll
              data-sveltekit-preload-data="hover"
              data-sveltekit-preload-code="viewport"
            >
              {value.name}
            </Button>
          {/if}
        {/each}
      </div>
    </div>
  {/each}
{/if}
